import React, { Component } from 'react';
import config from './../../../config';
import common from './../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import Swiper from 'react-id-swiper';

class ShowMore extends Component {
    constructor(props) {
        super(props);
        this.state = { isShowMore: false }
    }

    onCLickDelete() {
        let jLeagueId = this.props.jLeagueId;
        let jLeagueCode = this.props.jLeagueCode;
        this.props.onDeletePreviousLeagueClick(jLeagueId, jLeagueCode);
    }

    onChangeStateShowMore(flagP) {
        let flag = flagP ? flagP : !(this.state.isShowMore);
        this.setState({ isShowMore: flag });
    }

    render() {
        let self = this;
        let trans = self.props.trans;
        let isShowMore = self.state.isShowMore;
        let objStyle = { style: { display: 'block' } };
        return (
            <div className="si-more-options" onClick={ (e) => {
                e.stopPropagation();
                self.onChangeStateShowMore()
            } } tabIndex="0" onBlur={ () => {
                self.onChangeStateShowMore(false)
            } }>
                <i className="icon-ucl-more" />
                { isShowMore ? <OutsideNotifier
                    handler={ () => this.onChangeStateShowMore(false) }>
                    <div className="si-more-menu" { ...objStyle }>
                        <span onClick={ () => {
                            self.onCLickDelete()
                        } }>{ trans.delete }</span>
                    </div>
                </OutsideNotifier> : null }
            </div>)
    }
}

class League extends Component {
    constructor(props) {
        super(props);
        this.renderSwiper = this.renderSwiper.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goPrev = this.goPrev.bind(this);
        this.isBeginning = this.isBeginning.bind(this);
        this.isEnd = this.isEnd.bind(this);
        this.state = {
            isBeginning: false, isEnd: false,
            initialSlideDesktop: 0,
            initialSlideTab: 0,
            initialSlideMobile: 0,
            isSet: false,
            isShowMore: false,
            isEndOfSeason: false,
        };
        this.swiper = null;
    }

    componentDidMount() {
        let self = this;
        if (self.swiper) {
            self.swiper.off('slideChangeTransitionEnd').on('slideChangeTransitionEnd', function () {
                self.setState({ isBeginning: self.isBeginning(), isEnd: self.isEnd() }, () => {
                    // self.props.onChangeAactiveIndex(selfSwiper.activeIndex);
                });
            });
            setTimeout(function () {
                if (self.swiper) {
                    //self.swiper.slideTo(0, 0); 
                    self.setState({ isBeginning: self.isBeginning(), isEnd: self.isEnd() });
                }
            }, 0);
        }
        self.setState({
            isEndOfSeason: common.isEndOfSeason(self.props.gcStats.TrCode)
        }, () => {
            if (!this.state.isEndOfSeason) {
                let arrLeague = this.props.arrLeague
                if(arrLeague && arrLeague.length){
                    common.cardImpression('card-leagues', {variant : 'private leagues', position : '2'})
                }
                else{
                    common.cardImpression('card-leagues', {variant : 'no leagues', position : '2'})    

                }
            }
        })
    }

    renderSwiper(arrLeague, trans) {
        let self = this;
        let slides = null;
        let guid = common.getGUID();
        // let countToDisplayDesktop = 1;
        // let countToDisplayTab = 1;
        // let countToDisplayMobile = 1;
        let initialSlideDesktop = 0;
        // let initialSlideTab = 0;
        // let initialSlideMobile = 0;
        const params = {
            initialSlide: initialSlideDesktop,
            //pagination: '.swiper-pagination',
            slidesPerView: 'auto',//6,
            paginationClickable: true,
            spaceBetween: 10,
            freeMode: false,
            // containerClass: '',
            runCallbacksOnInit: true,
            observer: true,
        };
        // let arrRound = arrLeague;
        if (arrLeague) {
            arrLeague = arrLeague.concat({ isCreate: this.state.isEndOfSeason ? false : true });
            slides = (<Swiper { ...params } ref={ node => {
                if (node) this.swiper = node.swiper
            } }>
                { arrLeague.map((element, index) => {
                    let sLeagueName = element.LeagueName;
                    let jLeagueId = (element.LeagueId ? Number(element.LeagueId) : null);
                    let jLeagueCode = (element.LeagueCode ? element.LeagueCode : '');
                    let jCurRank = (element.CurRank ? Number(element.CurRank) : null);
                    let jMembers = (element.Members ? Number(element.Members) : 0);
                    let jTrend = (element.Trend ? Number(element.Trend) : 0);
                    let isLastSeason = (element.isLastSeason);
                    if (jCurRank === 1) {
                        jTrend = 4;
                    }
                    let sClasssTrend = config.enumTrend[jTrend];
                    let eventClick = {
                        onClick: () => {
                            self.onRedirectTo(('/league-leaderboard/' + jLeagueId), 'Leagues Card')
                        }
                    };
                    let isCreate = element.isCreate;
                    //create join box
                    if (isCreate) {
                        eventClick = {
                            onClick: () => {
                                self.onRedirectTo('/leagues/')
                            }
                        };
                        return (
                            <div key={ index } className="si-ylgs-boxes swiper-slide" { ...eventClick }>
                                <div className="si-ylgs-wrapper si-create-box">
                                    <div className="si-ygls-bx">
                                        <div className="si-create-icon">
                                            <i className="icon-ucl-add" />
                                        </div>
                                        <div className="si-join-txt">{ trans.lgCreateJoin }</div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    //trend box
                    else if (jTrend && !isLastSeason) {
                        return (
                            <div key={ index } className="si-ylgs-boxes swiper-slide" { ...eventClick }>
                                <div className="si-ygls-bx-rank">
                                    <div className="si-rank-title">{ trans.rank }</div>
                                    <div className="si-ylgs-rank-block">
                                        <span className={ "si-rank-pos-icon " + sClasssTrend } />
                                        <span className="si-rank-txt">{ jCurRank }</span>
                                    </div>
                                    <div className="si-ylgs-title"><span>{ sLeagueName }</span></div>
                                </div>
                            </div>
                        );
                    }
                    else if(this.state.isEndOfSeason) {
                      return null;
                    }
                    //members box
                    else {
                        let sBtnText = trans.view;
                        let nodeMoreOptions = null;
                        if (isLastSeason) {
                            sBtnText = trans.relaunch;
                            eventClick = {
                                onClick: () => {
                                    self.props.fnRelaunchAPI(guid, '', jLeagueCode, jLeagueId)
                                }
                            };
                            nodeMoreOptions = <ShowMore trans={ self.props.trans }
                                onDeletePreviousLeagueClick={ self.props.onDeletePreviousLeagueClick }
                                jLeagueId={ jLeagueId } jLeagueCode={ jLeagueCode } />;
                        }
                        return (
                            <div key={ index } className="si-ylgs-boxes swiper-slide" { ...eventClick } >
                                <div className="si-ygls-bx">
                                    { nodeMoreOptions }
                                    <div className="si-ylgs-title"><span>{ sLeagueName }</span></div>
                                    <div className="si-ylgs-block">
                                        <i className="icon-ucl-leagues-profile" /><span
                                            className="si-profile-txt">{ jMembers }</span>
                                    </div>
                                    <div className="si-ylgs-more si-more-btn">{ sBtnText } <i
                                        className="si-more-arrow-icon"> </i></div>
                                </div>
                            </div>
                        );
                    }
                })
                }
            </Swiper>)
        }
        return slides;
    }

    goNext() {
        if (this.swiper) {
            this.swiper.slideNext();
            this.setState({ isBeginning: this.isBeginning() });
            this.setState({ isEnd: this.isEnd() });
        }
    }

    goPrev() {
        if (this.swiper) {
            this.swiper.slidePrev();
            this.setState({ isBeginning: this.isBeginning() });
            this.setState({ isEnd: this.isEnd() });
        }
    }

    isBeginning() {
        //this.swiper.slideTo(1);
        return this.swiper.isBeginning;
    }

    isEnd() {
        return this.swiper.isEnd;
    }

    onRedirectTo(sPath, trackEvent) {
        // let sRedirect = (sPath + (jLeagueId ? jLeagueId : ''));
        let sRedirect = sPath;
        if (trackEvent) {
            common.customTracking(trackEvent);
        }
        this.props.onRedirectTo(sRedirect);
    }

    render() {
        let trans = this.props.trans;
        let arrLeague = this.props.arrLeague;

        if (arrLeague && arrLeague.length) {
            // arrLeague = [arrLeague[0], arrLeague[0], arrLeague[0], arrLeague[0], arrLeague[0], arrLeague[0]]

            return (<div className="si-card si-your-leagues-rank">
                <div className="si-carousal-block">
                    <div className="si-text-title">{ trans.yourLeagues }</div>
                    <div className="si-carousal-main">
                        {
                            this.renderSwiper(arrLeague, trans)
                        }
                    </div>

                    { this.state.isEndOfSeason ?
                        <div className="si-overview-crd--box">
                            <div className="si-overview-crd--box-fBox si-endofseason">
                                <div className="si-global-rank si-flexBox">
                                    <div className="si-glblrk-head"><span>{ trans.globalRank ? trans.globalRank : "GLOBAL RANK" }</span></div>
                                    <div className="si-glblrk-num"><span>{ this.props.gcStats && this.props.gcStats.TrRank ? this.props.gcStats.TrRank : "" }</span></div>
                                    <div className="si-glblrk-ttl"><span>{ this.props.gcStats && this.props.gcStats.TrPlayers ? this.props.gcStats.TrPlayers : "" }</span> { trans.totPlayers ? trans.totPlayers : "Total Players" }</div>
                                </div>
                            </div>
                        </div>
                        : ""

                    }


                    <div className="button-block" onClick={ () => {
                        common.customTracking('Fantasy Football - Leagues');

                        this.onRedirectTo('/leagues/', 'Leagues Card')
                    } }>
                        <div className="si-btn btn-lg">{ trans.goToLeague }</div>
                    </div>
                </div>


            </div>);
        }
        else {
            return (this.state.isEndOfSeason ? <div className="si-card si-overview-crd si-card-bg">
                <div className="si-overview-crd--box">
                    <div className="si-overview-crd--box-fBox si-endofseason">
                        <div className="si-global-rank si-flexBox">
                            <div className="si-glblrk-head"><span>{ trans.globalRank ? trans.globalRank : "GLOBAL RANK" }</span></div>
                            <div className="si-glblrk-num"><span>{ this.props.gcStats && this.props.gcStats.TrRank ? this.props.gcStats.TrRank : "" }</span></div>
                            <div className="si-glblrk-ttl"><span>{ this.props.gcStats && this.props.gcStats.TrPlayers ? this.props.gcStats.TrPlayers : "" }</span> { trans.totPlayers ? trans.totPlayers : "Total Players" }</div>
                        </div>
                    </div>
                </div>
            </div> : <div className="si-card si-my-leagues-card si-slider-card">
                    <div className="si-main-text-block">
                        <div className="text-block">
                            <div className="si-text-title">{ trans.lcHeading }</div>
                            <div className="si-text-descp">{ trans.lcMessage }</div>
                        </div>
                        <div className="button-block" onClick={ () => {
                            common.customTracking('Fantasy Football - Leagues');
                            this.onRedirectTo('/leagues/')
                        } }>
                            <div className="si-btn btn-lg">{ trans.lcButtonLabel }</div>
                        </div>
                    </div>
                </div>);
        }
    }
}

export default League;


// WEBPACK FOOTER //
// ./src/components/home/cards/League.js